// extracted by mini-css-extract-plugin
export default {"genderIcon":"ListOfStore_genderIcon__9SWe0","locationIcon":"ListOfStore_locationIcon__ZW51N"};